import React, { useEffect, useState, useRef } from "react"
import MetaTags from "react-meta-tags"
import { withRouter, Link } from "react-router-dom"
import { isEmpty } from "lodash"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import * as moment from "moment"
import { apiError } from "store/actions"
import {API_URL, sitename} from "../../../constants/constants"
import {
  getTokenFromLocalStorage,
  hasPermission,
} from "../../../helpers/helpers"
import { showMessage } from "components/Common/Toaster"

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import AddProductModal from "./AddProductModal"
import {deleteProduct, getAllProducts, updateProduct} from "store/products/actions"
import { updateOperatorProduct } from "store/operatorProducts/actions"
import { bulkUpdateProducts } from "helpers/repository"

// import EcommerceOrdersModal from "./EcommerceOrdersModal";

const ProductsTable = props => {
  const dispatch = useDispatch()

  const Products = useSelector(state => state?.products?.Index ?? [])
  const formErrors = useSelector(state => state?.CommonState)

  const [modal, setModal] = useState(false)
  const [productData, setProductData] = useState([])
  const [isEdit, setIsEdit] = useState(false)
  const [operator_product_ids, setOperatorProductIds] = useState([])

  //pagination customization
  const pageOptions = {
    sizePerPage: 10,
    totalSize: Products.length, // replace later with size(orders),
    custom: true,
  }
  const { SearchBar } = Search

  const toggle = () => {
    setModal(!modal)
  }

  const toLowerCase1 = str => {
    return str.toLowerCase()
  }

  const handleEditProductClick = arg => {
    const product = arg

    setProductData({
      id: product.id,
      name: product.name,
      display_order: product.display_order,
      is_active: product.is_active,
    })

    setIsEdit(true)
    dispatch(apiError(""))
    toggle()
  }

  const handleStatusChange = (row, e) => {
    const updatedRow = { ...row, is_active: e.target.checked ? 1 : 0 };
    e.preventDefault()
    const data = {
      id: updatedRow?.id,
      name: updatedRow?.name,
      display_order: updatedRow?.display_order,
      is_active : updatedRow?.is_active
    }
    dispatch(updateProduct(data, false))
  }

  var node = useRef()
  const onPaginationPageChange = page => {
    if (
        node &&
        node.current &&
        node.current.props &&
        node.current.props.pagination &&
        node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page)
    }
  }

  const handleDeleteProduct = product => {
    if (product.id !== undefined) {
      dispatch(deleteProduct(product.id))
    }
  }

  const handleAddNewProductClick = () => {
    setProductData("")
    setIsEdit(false)
    dispatch(apiError(""))
    toggle()
  }

  const handleValidDate = date => {
    const date1 = moment(new Date(date)).format("DD MMM Y")
    return date1
  }

  const defaultSorted = [
    {
      dataField: "display_order",
      order: "asc",
    },
  ]
  const handleChange = op => {
    bulkUpdateProducts(operator_product_ids, op.is_active).then(res => {
      showMessage("success", res.data.message)
      dispatch(getAllProducts())
    })
  }

  const productsColumns = [
    {
      dataField: "display_order",
      text: "Display Order",
      sort: true,
    },
    {
      dataField: "name",
      text: "Menu Title",
      sort: true,
    },
    {
      isDummyField: true,
      text: "Change Status",
      sort: true,
      formatter: (cellContent, row) => {
        return (
            <div className="form-check form-switch form-switch-md mb-3">
              <input
                  type="checkbox"
                  className="form-check-input"
                  id={`change_status_switch${row?.id}`}
                  onChange={e => handleStatusChange(row, e)}
                  checked={row?.is_active === 1}
              />
            </div>
        )
      },
    },
    {
      dataField: "action",
      isDummyField: true,
      text: "Action",
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, product) => (
          <>
            <div className="d-flex gap-3">
              {hasPermission("update-products") && (
                  <Link
                      to="#"
                      className="text-success"
                      onClick={() => handleEditProductClick(product)}
                  >
                    <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                    <UncontrolledTooltip placement="top" target="edittooltip">
                      Edit
                    </UncontrolledTooltip>
                  </Link>
              )}
              {hasPermission("delete-products") && (
                  <Link
                      to="#"
                      className="text-danger"
                      onClick={() => handleDeleteProduct(product)}
                  >
                    <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                    <UncontrolledTooltip placement="top" target="deletetooltip">
                      Delete
                    </UncontrolledTooltip>
                  </Link>
              )}
            </div>
          </>
      ),
    },
  ]


  return (
      <React.Fragment>
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="product_id"
                      columns={productsColumns}
                      data={props.Products}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                            keyField="product_id"
                            data={props.Products}
                            columns={productsColumns}
                            bootstrap4
                            search
                        >
                          {toolkitProps => (
                              <React.Fragment>
                                <Row className="mb-2">
                                  <Col sm="4">
                                    <Row>
                                      <Col sm="6">
                                        <div className="search-box me-2 mb-2 d-inline-block">
                                          <div className="position-relative">
                                            <SearchBar
                                                {...toolkitProps.searchProps}
                                            />
                                            <i className="bx bx-search-alt search-icon" />
                                          </div>
                                        </div>
                                      </Col>
                                      {/*<Col sm="6">*/}
                                      {/*  <Select*/}
                                      {/*    options={[*/}
                                      {/*      {*/}
                                      {/*        label: "Enable",*/}
                                      {/*        value: "Enable",*/}
                                      {/*        is_active: 1,*/}
                                      {/*      },*/}
                                      {/*      {*/}
                                      {/*        label: "Disable",*/}
                                      {/*        value: "Disable",*/}
                                      {/*        is_active: 0,*/}
                                      {/*      },*/}
                                      {/*    ]}*/}
                                      {/*    classNamePrefix="select2-selection"*/}
                                      {/*    onChange={handleChange}*/}
                                      {/*    maxMenuHeight={150}*/}
                                      {/*  />*/}
                                      {/*</Col>*/}
                                    </Row>
                                  </Col>
                                  {hasPermission("create-products") && (
                                      <Col sm="8">
                                        <div className="text-sm-end">
                                          <Button
                                              type="button"
                                              color="success"
                                              className="btn-rounded  mb-2 me-2"
                                              onClick={handleAddNewProductClick}
                                          >
                                            <i className="mdi mdi-plus me-1" />
                                            Add New
                                          </Button>
                                        </div>
                                      </Col>
                                  )}
                                </Row>
                                <Row>
                                  <Col xl="12">
                                    <div className="table-responsive">
                                      <BootstrapTable
                                          keyField="display_order"
                                          responsive
                                          bordered={false}
                                          striped={false}
                                          defaultSorted={defaultSorted}
                                          classes={
                                            "table align-middle table-nowrap table-check"
                                          }
                                          headerWrapperClasses={"table-light"}
                                          {...toolkitProps.baseProps}
                                          {...paginationTableProps}
                                          ref={node}
                                      />
                                    </div>
                                    <AddProductModal
                                        isEdit={isEdit}
                                        productData={productData}
                                        modal={modal}
                                        toggle={toggle}
                                        setProductData={setProductData}
                                        formErrors={formErrors}
                                    />
                                  </Col>
                                </Row>
                                <Row className="align-items-md-center mt-30">
                                  <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                    <PaginationListStandalone {...paginationProps} />
                                  </Col>
                                </Row>
                              </React.Fragment>
                          )}
                        </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
  )
}

export default withRouter(ProductsTable)
